import React, { useEffect, useState } from "react";
import T from "prop-types";
import { get } from "lodash";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import { sync as syncAcctg } from "MODULES/SalesOrders/actions";
import { connect } from "react-redux";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { CREATED_AT, DISABLE_QB_SYNC, ID } from "APP_ROOT/constants";
import moment from "moment";
import api from "APP_ROOT/api";
import { STORE_OWNER } from "MODULES/inventories/constants";

function Sync({ onConfirm, salesOrder }) {
  const [visible, setVisible] = useState(false);
  const [settings, setSettings] = useState(null);
  const locationId = salesOrder.getIn([STORE_OWNER, ID]);
  if (!locationId) return null;

  useEffect(() => {
    api.locations.locationSetting
      .quickbooksLocationSetting(locationId)
      .then(({ data }) => {
        setSettings(get(data, "settings.quickbooks", {}));

        return function cleanup() {};
      });
  }, []);

  if (!get(settings, "ar_account")) {
    return null;
  }

  if (salesOrder.get(DISABLE_QB_SYNC)) {
    return null;
  }

  const syncDate = get(settings, "sync_date");
  const createdAt = moment(salesOrder.get(CREATED_AT));

  if (syncDate && moment(syncDate) > moment(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  return (
    <DropDownItem onClick={() => setVisible(true)}>
      <Icon name="refresh" fixed />
      &nbsp;Sync Accounting
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setVisible(false)}
        open={visible}
        btnText="Yes, Sync w/ Quickbooks"
        cancelText="Cancel"
        icon={<i className="fa fa-fw fa-refresh" />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to sync the SO?
        <p>
          Please ensure the Customer has a linked account for the store
          location.
        </p>
      </ConfirmAction>
    </DropDownItem>
  );
}

export default connect(undefined, dispatch => ({
  onConfirm: () => dispatch(syncAcctg())
}))(withSalesOrder(Sync));

Sync.propTypes = {
  onConfirm: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Sync/Sync.jsx